<div class="message-container">
    @if (selectedThread() !== null) {
        <div class="subject-container">
            <span class="subject-container-heading">{{ selectedThread()!.subject }}</span>
            <div class="subject-container-actions">
                <!-- <cll-icon class="email-icon">forward</cll-icon>
                <cll-icon class="email-icon" type="outlined">reply_all</cll-icon> -->
                @if (!isCurrentUserRemoved) {
                    <button cll-icon-button (click)="addReply({ threadId: selectedThread()!.id, subject: selectedThread()!.subject })">
                        <cll-icon class="email-icon" type="outlined">reply</cll-icon>
                    </button>
                }
                <!-- <div class="delete-icon-container">
                    <cll-icon class="email-icon" type="outlined">delete</cll-icon>
                </div> -->
            </div>
        </div>

        <div class="participants-container">
            <span class="participants-title">Participants:</span>
            <div class="participants-chips-container">
                <cll-chip-collection>
                    @for (participant of sortedParticipants; track participant.id) {
                        @if (participant.user_id === selectedThread()!.sender_id) {
                          <cll-input-chip cllTooltip="Created of thread">
                            <cll-icon cllChipIcon class="thread_creator">account_circle</cll-icon>
                            {{ getDisplayName(participant.user.person) }}
                          </cll-input-chip>
                        } @else {
                          @if (!isCurrentUserRemoved) {
                            <cll-input-chip (remove)="onRemove(participant)">
                              {{ getDisplayName(participant.user.person) }}
                            </cll-input-chip>
                          } @else {
                            <cll-input-chip>
                              {{ getDisplayName(participant.user.person) }}
                            </cll-input-chip>
                          }
                        }
                    }
                    @if (!isCurrentUserRemoved) {
                        <cll-input-chip (click)="addParticipant({ threadId: selectedThread()!.id, participants: selectedThread()!.participants})">
                            <cll-icon>add</cll-icon>
                        </cll-input-chip>
                    }
                </cll-chip-collection>

            </div>
        </div>

        @if (isCurrentUserRemoved) {
            <div class="removed-participant-notice">
                <cll-panel-tonal colour="warning">
                    <cll-icon cllPanelIcon>info</cll-icon>
                    <div>
                        <span class="panel-text-header">You have been removed from this conversation</span>
                        <span>You can view message history up to when you were removed.</span>
                    </div>
                </cll-panel-tonal>
            </div>
        }

        <div class="messages-container">
            @for (message of visibleMessages; track message.id) {
                @if (!message.remove_user_indicator) {
                    <div class="message">
                            <div class="message-header">
                                <div class="message-sender-date">
                                    @if (message.sender_id){
                                        <span class="message-header-sender">{{ message.sender.person.given_name }} {{ message.sender.person.family_name }}</span>
                                    } @else {
                                        <span class="message-header-sender"><cll-badge>System Message</cll-badge></span>
                                    }
                                    <span class="message-header-date">{{ message.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
                                </div>
                            </div>
                            <div class="message-content">
                                <span class="message-details">{{ message.content }}</span>
                            </div>
                    </div>
                    } @else {
                        <div class="remove-message">
                            <span class="remove-message-title">{{ message.content }}</span>
                            <span class="remove-message-date">{{ message.created_at | date: 'EEE dd MMM yyyy HH:mm' }}</span>
                        </div>
                    }
            }
        </div>
        <div class="message-footer">
            <div class="message-footer-buttons">
                <!-- <button cll-button type="button" colour="variant">
                    <cll-icon>forward</cll-icon>
                    Forward
                </button>
                <button cll-button type="button" colour="variant">
                    <cll-icon type="outlined">reply_all</cll-icon>
                    Reply All
                </button> -->
                @if (!isCurrentUserRemoved) {
                    <button cll-filled-button colour="secondary" (click)="addReply({ threadId: selectedThread()!.id, subject: selectedThread()!.subject })">
                        <cll-icon type="outlined">reply</cll-icon>
                        Reply
                    </button>
                }
            </div>
        </div>
    }
    @else {
        <div class="no-thread-container">
            <cll-icon [size]="48" type="outlined" class="no-mail-icon">mail_off</cll-icon>
            <div class="no-message-text-container">
                <span class="no-message-text">No message selected</span>
                <span
                    class="no-message-detail">Select a message from your inbox to read it here, or create a message</span>
            </div>
            <button class="add-button" cll-filled-button colour="secondary" (click)="createNewMessage()">
                <cll-icon type="outlined">add</cll-icon>
                Create new message
            </button>
        </div>
    }
</div>
